<div class="override-audit-dialog">
    <div *ngIf="loading" class="loading-indicator">
        <span class="k-i-loading"></span> Loading...
    </div>
    <div *ngIf="error" class="error-message">
        {{ error }}
    </div>
    <kendo-grid *ngIf="overrides.length > 0 && !loading"
                [data]="overrides"
                [height]="320"
                [scrollable]="'scrollable'">
        <kendo-grid-column field="overrideDateTime" title="Date/Time" [width]="130"></kendo-grid-column>
        <kendo-grid-column field="user" title="User" [width]="150"></kendo-grid-column>
        <kendo-grid-column field="status" title="Status" [width]="120"></kendo-grid-column>
        <kendo-grid-column field="overrideProfile" title="Profile" [width]="80"></kendo-grid-column>
        <kendo-grid-column field="action" title="Action" [width]="90"></kendo-grid-column>
        <kendo-grid-column field="comment" title="Comment" [width]="200"></kendo-grid-column>
    </kendo-grid>
</div>
